var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4495_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3221 5.6875H5.68848V18.3211H18.3221V5.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3115 24.0005L23.9995 18.3125H18.3115V24.0005Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 5.6875H18.3115V18.3211H23.9995V5.6875Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3221 18.3125H5.68848V24.0005H18.3221V18.3125Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3125V22.0997C0 23.1509 0.8496 24.0005 1.896 24.0005H5.6832V18.3125H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 5.688V1.896C23.9996 0.8496 23.15 0 22.1036 0H18.3164V5.688H23.9996Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.312 0H1.896C0.8496 0 0 0.8496 0 1.896V18.3168H5.688V5.688H18.3216L18.312 0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2751 15.4848C7.7999 15.168 7.4783 14.7024 7.2959 14.0832L8.3951 13.632C8.4959 14.0112 8.6687 14.304 8.9135 14.5152C9.1631 14.7216 9.4607 14.8224 9.8111 14.8224C10.1663 14.8224 10.4783 14.7168 10.7327 14.496C10.9919 14.2752 11.1215 13.9968 11.1215 13.6608C11.1215 13.32 10.9871 13.0368 10.7135 12.816C10.4399 12.6 10.0991 12.4896 9.6911 12.4896H9.0575V11.4048H9.6239C9.9743 11.4048 10.2719 11.3088 10.5119 11.1168C10.7519 10.9296 10.8719 10.6656 10.8719 10.3392C10.8719 10.0416 10.7663 9.81123 10.5503 9.63843C10.3343 9.46563 10.0607 9.37443 9.7343 9.37443C9.4127 9.37443 9.1583 9.46082 8.9663 9.63363C8.7791 9.80642 8.6351 10.0224 8.5535 10.2672L7.4687 9.81603C7.6127 9.40803 7.8767 9.04803 8.2607 8.73603C8.6495 8.42883 9.1439 8.26562 9.7439 8.26562C10.1903 8.26562 10.5887 8.35203 10.9391 8.52483C11.2895 8.69763 11.5727 8.93762 11.7743 9.23522C11.9759 9.53762 12.0767 9.88323 12.0767 10.2624C12.0767 10.6512 11.9807 10.9728 11.7935 11.2464C11.6063 11.5152 11.3759 11.7216 11.1023 11.8656V11.9328C11.4527 12.0768 11.7599 12.3168 11.9855 12.624C12.2159 12.9312 12.3263 13.3008 12.3263 13.728C12.3263 14.16 12.2207 14.5392 11.9999 14.8752C11.7839 15.2112 11.4815 15.4752 11.0975 15.6672C10.7135 15.8592 10.2815 15.96 9.8015 15.96C9.2591 15.96 8.7455 15.8016 8.2751 15.4848ZM15.0047 10.0464L13.7999 10.92L13.1999 10.008L15.3551 8.45283H16.1855V15.7968H15.0047V10.0464Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4495_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.4df0b281923a137077aa3560feeb4b4a.svg";
export { ForwardRef as ReactComponent };